import {Provider} from 'react-redux';
import {PropsWithChildren} from "react";
import {Action, Store} from "redux";

type Props = {
    store: Store<any, Action>
}

export default function ProviderWrapper(
    {children, store}: PropsWithChildren<Props>
) {
    return <Provider store={store}>{children}</Provider>
}